interface CheckMarkProps {
  transform: {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    stroke: string;
    strokeWidth: number;
    transform: string;
  };
}
export default function CheckMark(props: CheckMarkProps) {
  const { x1, y1, x2, y2, stroke, strokeWidth, transform } = props?.transform || {};
  return (
    <>
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={stroke}
        strokeWidth={strokeWidth}
        transform={transform}
      />
      <line
        x1={x2}
        y1={y1}
        x2={x1}
        y2={y2}
        stroke={stroke}
        strokeWidth={strokeWidth}
        transform={transform}
      />
    </>
  );
}
